// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader-saving-PX69S {
	font-size: 18px;
	color: var(--secondary-bg);
}

.Loader-savingDots-H5Rx6 {
	font-size: 48px;
}

.Loader-saving-PX69S span {
	-webkit-animation-name: Loader-blink-x6pAj;
	        animation-name: Loader-blink-x6pAj;
	-webkit-animation-duration: 1.4s;
	        animation-duration: 1.4s;
	-webkit-animation-iteration-count: infinite;
	        animation-iteration-count: infinite;
	-webkit-animation-fill-mode: both;
	        animation-fill-mode: both;
	color: var(--secondary-bg);
}

.Loader-saving-PX69S span:nth-child(2) {
	-webkit-animation-delay: .2s;
	        animation-delay: .2s;
}

.Loader-saving-PX69S span:nth-child(3) {
	-webkit-animation-delay: .4s;
	        animation-delay: .4s;
}

@-webkit-keyframes Loader-blink-x6pAj {
	0% {
		opacity: .2;
	}

	20% {
		opacity: 1;
	}

	100% {
		opacity: .2;
	}
}

@keyframes Loader-blink-x6pAj {
	0% {
		opacity: .2;
	}

	20% {
		opacity: 1;
	}

	100% {
		opacity: .2;
	}
}

.Loader-textCenter-Yuyzu {
	text-align: center;
}

.Loader-iconColor-UCpl5 {
	color: var(--primary-bg);
	font-size: 48px;
}

/* custom circle loader */

.Loader-customCircleLoad-rGzws {
	border-radius: 50%;
	border-style: solid;
	-webkit-animation:
		Loader-customCircleOne-qYpW4 0.8s infinite linear alternate,
		Loader-customCircleTwo-jxuIe 1.6s infinite linear;
	        animation:
		Loader-customCircleOne-qYpW4 0.8s infinite linear alternate,
		Loader-customCircleTwo-jxuIe 1.6s infinite linear;
	display: inline-block;
	vertical-align: middle;
}

@-webkit-keyframes Loader-customCircleOne-qYpW4 {
	0% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)
	}

	12.5% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)
	}

	25% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)
	}

	50% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
	}

	62.5% {
		clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
	}

	75% {
		clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)
	}

	100% {
		clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)
	}
}

@keyframes Loader-customCircleOne-qYpW4 {
	0% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)
	}

	12.5% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)
	}

	25% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)
	}

	50% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
	}

	62.5% {
		clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
	}

	75% {
		clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)
	}

	100% {
		clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)
	}
}

@-webkit-keyframes Loader-customCircleTwo-jxuIe {
	0% {
		-webkit-transform: scaleY(1) rotate(0deg);
		        transform: scaleY(1) rotate(0deg)
	}

	49.99% {
		-webkit-transform: scaleY(1) rotate(135deg);
		        transform: scaleY(1) rotate(135deg)
	}

	50% {
		-webkit-transform: scaleY(-1) rotate(0deg);
		        transform: scaleY(-1) rotate(0deg)
	}

	100% {
		-webkit-transform: scaleY(-1) rotate(-135deg);
		        transform: scaleY(-1) rotate(-135deg)
	}
}

@keyframes Loader-customCircleTwo-jxuIe {
	0% {
		-webkit-transform: scaleY(1) rotate(0deg);
		        transform: scaleY(1) rotate(0deg)
	}

	49.99% {
		-webkit-transform: scaleY(1) rotate(135deg);
		        transform: scaleY(1) rotate(135deg)
	}

	50% {
		-webkit-transform: scaleY(-1) rotate(0deg);
		        transform: scaleY(-1) rotate(0deg)
	}

	100% {
		-webkit-transform: scaleY(-1) rotate(-135deg);
		        transform: scaleY(-1) rotate(-135deg)
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,0CAAqB;SAArB,kCAAqB;CACrB,gCAAwB;SAAxB,wBAAwB;CACxB,2CAAmC;SAAnC,mCAAmC;CACnC,iCAAyB;SAAzB,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA;CACC,4BAAoB;SAApB,oBAAoB;AACrB;;AAEA;CACC,4BAAoB;SAApB,oBAAoB;AACrB;;AAEA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,WAAW;CACZ;AACD;;AAZA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,eAAe;AAChB;;AAEA,yBAAyB;;AAEzB;CACC,kBAAkB;CAClB,mBAAmB;CACnB;;mDAEqC;SAFrC;;mDAEqC;CACrC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AA5BA;CACC;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;;CAEA;EACC;CACD;AACD;;AAEA;CACC;EACC,yCAAgC;UAAhC;CACD;;CAEA;EACC,2CAAkC;UAAlC;CACD;;CAEA;EACC,0CAAiC;UAAjC;CACD;;CAEA;EACC,6CAAoC;UAApC;CACD;AACD;;AAhBA;CACC;EACC,yCAAgC;UAAhC;CACD;;CAEA;EACC,2CAAkC;UAAlC;CACD;;CAEA;EACC,0CAAiC;UAAjC;CACD;;CAEA;EACC,6CAAoC;UAApC;CACD;AACD","sourcesContent":[".saving {\n\tfont-size: 18px;\n\tcolor: var(--secondary-bg);\n}\n\n.savingDots {\n\tfont-size: 48px;\n}\n\n.saving span {\n\tanimation-name: blink;\n\tanimation-duration: 1.4s;\n\tanimation-iteration-count: infinite;\n\tanimation-fill-mode: both;\n\tcolor: var(--secondary-bg);\n}\n\n.saving span:nth-child(2) {\n\tanimation-delay: .2s;\n}\n\n.saving span:nth-child(3) {\n\tanimation-delay: .4s;\n}\n\n@keyframes blink {\n\t0% {\n\t\topacity: .2;\n\t}\n\n\t20% {\n\t\topacity: 1;\n\t}\n\n\t100% {\n\t\topacity: .2;\n\t}\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.iconColor {\n\tcolor: var(--primary-bg);\n\tfont-size: 48px;\n}\n\n/* custom circle loader */\n\n.customCircleLoad {\n\tborder-radius: 50%;\n\tborder-style: solid;\n\tanimation:\n\t\tcustomCircleOne 0.8s infinite linear alternate,\n\t\tcustomCircleTwo 1.6s infinite linear;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n@keyframes customCircleOne {\n\t0% {\n\t\tclip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)\n\t}\n\n\t12.5% {\n\t\tclip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)\n\t}\n\n\t25% {\n\t\tclip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)\n\t}\n\n\t50% {\n\t\tclip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)\n\t}\n\n\t62.5% {\n\t\tclip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)\n\t}\n\n\t75% {\n\t\tclip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)\n\t}\n\n\t100% {\n\t\tclip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)\n\t}\n}\n\n@keyframes customCircleTwo {\n\t0% {\n\t\ttransform: scaleY(1) rotate(0deg)\n\t}\n\n\t49.99% {\n\t\ttransform: scaleY(1) rotate(135deg)\n\t}\n\n\t50% {\n\t\ttransform: scaleY(-1) rotate(0deg)\n\t}\n\n\t100% {\n\t\ttransform: scaleY(-1) rotate(-135deg)\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"saving": `Loader-saving-PX69S`,
	"savingDots": `Loader-savingDots-H5Rx6`,
	"blink": `Loader-blink-x6pAj`,
	"textCenter": `Loader-textCenter-Yuyzu`,
	"iconColor": `Loader-iconColor-UCpl5`,
	"customCircleLoad": `Loader-customCircleLoad-rGzws`,
	"customCircleOne": `Loader-customCircleOne-qYpW4`,
	"customCircleTwo": `Loader-customCircleTwo-jxuIe`
};
module.exports = ___CSS_LOADER_EXPORT___;
